(function() {
  "use strict";
  var le = function(v, z, d) {
    return Math.min(d, Math.max(z, v));
  }, Ue = function(v) {
    return 1 - Math.pow(1 - v, 3);
  }, K = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches, ue = 0;
  function Q(v) {
    ue = Math.max(0, ue + (v ? 1 : -1)), document.documentElement.classList.toggle("bz-lock", ue > 0);
  }
  function Ve(v, z) {
    z = z || "{{amount_with_comma_separator}} €";
    var d = (v || 0) / 100;
    function r(b, fe, J) {
      for (var q = d.toFixed(b).split("."), H = q[0], U = "", F = 0; F < H.length; F++)
        F > 0 && (H.length - F) % 3 === 0 && (U += fe), U += H[F];
      return q[0] = U, q.join(J);
    }
    var m = z.indexOf("{{"), P = z.indexOf("}}", m);
    if (m < 0 || P < 0) return r(2, ".", ",") + " €";
    var N = z.slice(m + 2, P).trim(), M;
    switch (N) {
      case "amount":
        M = r(2, ",", ".");
        break;
      case "amount_no_decimals":
        M = r(0, ",", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        M = r(0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        M = r(2, "'", ".");
        break;
      case "amount_with_space_separator":
        M = r(2, " ", ",");
        break;
      default:
        M = r(2, ".", ",");
    }
    return (z.slice(0, m) + M + z.slice(P + 2)).replace(/<[^>]*>/g, "");
  }
  function we(v) {
    if (!v || v.dataset.bzReady) return;
    v.dataset.bzReady = "1";
    var z = v.querySelector("[data-bz-config]"), d = JSON.parse(z.textContent), r = function(e, t) {
      return (t || v).querySelector(e);
    }, m = function(e, t) {
      return Array.prototype.slice.call((t || v).querySelectorAll(e));
    }, P = r("[data-bz-top]"), N = 0;
    function M() {
      N = P ? P.offsetHeight : 0, v.style.setProperty("--top", N + "px");
    }
    M(), window.ResizeObserver && P && new ResizeObserver(function() {
      M(), typeof V == "function" && V();
    }).observe(P);
    var b = { items: [], count: 0 }, fe = 0;
    function J(e, t) {
      var n = { headers: { Accept: "application/json" } };
      return t && (n.method = "POST", n.headers["Content-Type"] = "application/json", n.body = JSON.stringify(t)), fetch(e, n).then(function(i) {
        return i.json().catch(function() {
          return {};
        }).then(function(c) {
          if (!i.ok) throw new Error(c.description || c.message || "Napaka pri košarici.");
          return c;
        });
      });
    }
    function q() {
      return d.preview ? (Z(), Promise.resolve()) : J(d.routes.cart + ".js").then(function(e) {
        b.items = e.items || [], b.count = e.item_count || 0, Z();
      }).catch(function() {
      });
    }
    function H(e) {
      return d.preview ? (e.forEach(function(t) {
        var n = JSON.stringify(t.properties || {}), i = b.items.find(function(c) {
          return c.variant_id === t.id && JSON.stringify(c.properties || {}) === n;
        });
        i ? i.quantity += t.quantity : b.items.push({ key: "k" + ++fe, variant_id: t.id, quantity: t.quantity, properties: t.properties || null });
      }), b.count = b.items.reduce(function(t, n) {
        return t + n.quantity;
      }, 0), Z(), Promise.resolve()) : J(d.routes.add + ".js", { items: e }).then(q);
    }
    function U(e, t) {
      return d.preview ? (b.items = b.items.map(function(n) {
        return n.key === e ? Object.assign({}, n, { quantity: t }) : n;
      }).filter(function(n) {
        return n.quantity > 0;
      }), b.count = b.items.reduce(function(n, i) {
        return n + i.quantity;
      }, 0), Z(), Promise.resolve()) : J(d.routes.change + ".js", { id: e, quantity: t }).then(q);
    }
    function F(e) {
      return b.items.find(function(t) {
        return t.variant_id === e && (!t.properties || Object.keys(t.properties).length === 0);
      });
    }
    function Z() {
      m("[data-bz-cart-count]").forEach(function(e) {
        e.textContent = b.count;
      }), m("[data-bz-product]").forEach(function(e) {
        var t = d.variants[e.dataset.bzProduct], n = F(t), i = n ? n.quantity : 0;
        r("[data-bz-add]", e).hidden = i > 0, r("[data-bz-step]", e).hidden = i === 0, r("[data-bz-qty]", e).textContent = i + " × 12-pack";
      });
    }
    var ee = r("[data-bz-toast]"), Ce;
    function te(e, t) {
      r("[data-bz-toast-msg]", ee).textContent = e, ee.classList.toggle("is-error", !!t), ee.classList.add("is-on"), clearTimeout(Ce), Ce = setTimeout(function() {
        ee.classList.remove("is-on");
      }, t ? 5e3 : 3200);
    }
    function B(e, t) {
      e.classList.toggle("is-busy", t);
    }
    function ve(e) {
      te(e && e.message ? e.message : "Nekaj je šlo narobe. Poskusi znova.", !0);
    }
    function Me() {
      te("Izdelek še ni povezan. Izberi ga v urejevalniku teme.", !0);
    }
    m("[data-bz-product]").forEach(function(e) {
      var t = e.dataset.bzProduct, n = d.variants[t], i = r("[data-bz-add]", e), c = r("[data-bz-step]", e);
      function a(s) {
        if (!n) return Me();
        B(s, !0), H([{ id: n, quantity: 1 }]).then(function() {
          te("Dodano v košarico.");
        }).catch(ve).finally(function() {
          B(s, !1);
        });
      }
      i.addEventListener("click", function() {
        a(i);
      }), r("[data-bz-inc]", e).addEventListener("click", function() {
        a(c);
      }), r("[data-bz-dec]", e).addEventListener("click", function() {
        var s = F(n);
        s && (B(c, !0), U(s.key, s.quantity - 1).catch(ve).finally(function() {
          B(c, !1);
        }));
      });
    });
    var T = r("[data-bz-gate]");
    if (T) {
      var Se = r("[data-bz-gate-ask]", T), Te = r("[data-bz-gate-denied]", T);
      T.hidden || (Q(!0), r("[data-bz-accept]", T).focus({ preventScroll: !0 })), r("[data-bz-accept]", T).addEventListener("click", function() {
        try {
          localStorage.setItem("bozu_age_ok", "1");
        } catch {
        }
        T.hidden = !0, Q(!1);
      }), r("[data-bz-deny]", T).addEventListener("click", function() {
        Se.hidden = !0, Te.hidden = !1;
      }), r("[data-bz-back]", T).addEventListener("click", function() {
        Te.hidden = !0, Se.hidden = !1;
      });
    }
    var ae = r("[data-bz-menu]"), pe = r("[data-bz-menu-open]");
    function ne(e) {
      ae.hidden !== !e && (ae.hidden = !e, Q(e), pe.setAttribute("aria-expanded", String(e)), (e ? r("[data-bz-menu-close]") : pe).focus());
    }
    pe.addEventListener("click", function() {
      ne(!0);
    }), r("[data-bz-menu-close]").addEventListener("click", function() {
      ne(!1);
    }), m("a", ae).forEach(function(e) {
      e.addEventListener("click", function() {
        ne(!1);
      });
    });
    var Ae = r("[data-bz-hero]"), I = r("[data-bz-stage]"), Xe = r("[data-bz-ground]"), Pe = r("[data-bz-hero-hint]"), Ye = { green: "#B3ECAC", peach: "#F9B576" }, re = "green", Fe = 0, me = !0, l = null, ie = 0, g = { on: !1, x: 0, spin: 0, vel: 35e-4, id: null };
    function $e(e, t, n, i) {
      var c = document.createElement("canvas");
      c.width = Math.ceil(n), c.height = Math.ceil(i);
      var a = c.getContext("2d");
      return a.drawImage(e, 0, 0, n, i), a.globalCompositeOperation = "source-in", a.fillStyle = t, a.fillRect(0, 0, n, i), c;
    }
    function _e(e) {
      var t = window.THREE, n = 1440, i = 1024, c = document.createElement("canvas");
      c.width = n, c.height = i;
      var a = c.getContext("2d"), s = e === "green" ? { base: "#268A38", leafFill: "#237F33", vein: "#7CC667", ink: "#0F3F1B", text: "#F1F1EA", name: "GREEN" } : { base: "#EC8B2C", leafFill: "#E4822A", vein: "#F8C583", ink: "#7A3A08", text: "#FFF8EE", name: "PEACH" };
      a.fillStyle = s.base, a.fillRect(0, 0, n, i);
      function f(x, C, k, p, ze) {
        a.save(), a.translate(x, C), a.rotate(ze), a.beginPath(), a.moveTo(0, -p / 2), a.bezierCurveTo(k * 0.62, -p * 0.28, k * 0.5, p * 0.3, 0, p / 2), a.bezierCurveTo(-k * 0.5, p * 0.3, -k * 0.62, -p * 0.28, 0, -p / 2), a.closePath(), a.fillStyle = s.leafFill, a.fill(), a.lineWidth = 3.2, a.strokeStyle = s.vein, a.stroke(), a.save(), a.clip(), a.beginPath(), a.moveTo(0, p / 2), a.lineTo(0, -p / 2);
        for (var O = -p / 2 + 18; O < p / 2; O += 17)
          a.moveTo(0, O), a.lineTo(k * 0.6, O - k * 0.42), a.moveTo(0, O), a.lineTo(-k * 0.6, O - k * 0.42);
        a.lineWidth = 2.4, a.stroke(), a.restore(), a.restore();
      }
      for (var y = 120, h = 270, G = n / y, A = 0, w = i + 60; w > -120; A++, w -= h * 0.52)
        for (var L = 0; L < G; L++) {
          var E = L * y + (A % 2 ? y / 2 : 0), ke = ((A * 7 + L * 3) % 5 - 2) * 0.07;
          f(E, w, y, h, ke), E < y && f(E + n, w, y, h, ke), E > n - y && f(E - n, w, y, h, ke);
        }
      function Ee(x, C, k, p, ze, O, ot, st) {
        a.font = p, a.letterSpacing = ze + "px", a.textAlign = "center", a.textBaseline = "middle", a.lineJoin = "round", a.lineWidth = st, a.strokeStyle = ot, a.strokeText(x, C, k), a.fillStyle = O, a.fillText(x, C, k);
      }
      var xe = "ALCOHOLIC ICED TEA  •  65 CALORIES  •  REAL TEA EXTRACT  •  4.5% VOL.  •  VEGAN  •  ";
      a.font = "600 30px Manrope, sans-serif", a.letterSpacing = "3px";
      for (var ce = a.measureText(xe).width, de = n / 2 - ce * 0.2 - ce; de < n + ce; de += ce)
        a.textAlign = "left", a.textBaseline = "middle", a.lineWidth = 5, a.lineJoin = "round", a.strokeStyle = s.ink, a.strokeText(xe, de, 64), a.fillStyle = s.text, a.fillText(xe, de, 64);
      var W = n / 2;
      Ee("HARD ICED TEA", W, 872, "600 30px Manrope, sans-serif", 3, s.text, s.ink, 5), Ee(s.name, W, 924, "800 56px Manrope, sans-serif", 3, "#FFFFFF", s.ink, 6), Ee("4.5% VOL.", W, 972, "600 28px Manrope, sans-serif", 3, s.text, s.ink, 5), a.save(), a.translate(W, 826), a.rotate(Math.PI / 4), a.lineWidth = 5, a.strokeStyle = s.ink, a.strokeRect(-15, -15, 30, 30), a.fillStyle = s.text, a.fillRect(-15, -15, 30, 30), a.fillStyle = s.base, a.beginPath(), a.ellipse(0, 0, 6, 11, -Math.PI / 4, 0, Math.PI * 2), a.fill(), a.restore();
      var D = new t.Texture(c);
      D.wrapS = t.RepeatWrapping, D.offset.x = 0.5, D.anisotropy = 8, D.needsUpdate = !0;
      var j = new Image();
      return j.crossOrigin = "anonymous", j.onload = function() {
        try {
          var x = 650, C = x * (j.naturalHeight / j.naturalWidth || 0.229), k = $e(j, s.ink, x, C);
          a.save(), a.translate(W, 468), a.rotate(-Math.PI / 2), a.globalAlpha = 0.55, [[-3, 0], [3, 0], [0, -3], [0, 3], [-2, -2], [2, 2], [-2, 2], [2, -2]].forEach(function(p) {
            a.drawImage(k, -x / 2 + p[0], -C / 2 + p[1], x, C);
          }), a.globalAlpha = 1, a.drawImage(j, -x / 2, -C / 2, x, C), a.restore(), a.font = "600 22px Manrope, sans-serif", a.fillStyle = s.text, a.textAlign = "center", a.fillText("®", W + C / 2 + 10, 468 - x / 2 + 6), D.needsUpdate = !0;
        } catch {
        }
      }, j.src = d.wordmarkUrl, D;
    }
    function he() {
      if (l) {
        var e = I.clientWidth || 1, t = I.clientHeight || 1;
        l.r.setSize(e, t, !1), l.cam.aspect = e / t, l.cam.fov = e / t < 0.62 ? 34 : 30, l.cam.updateProjectionMatrix();
      }
    }
    function Oe() {
      var e = window.THREE;
      if (!(!e || l)) {
        var t = new e.Scene(), n = new e.PerspectiveCamera(30, 1, 0.1, 100);
        n.position.set(0, 0.1, 11.2);
        var i;
        try {
          i = new e.WebGLRenderer({ antialias: !0, alpha: !0 });
        } catch {
          return;
        }
        i.setPixelRatio(Math.min(2, window.devicePixelRatio || 1)), I.appendChild(i.domElement), t.add(new e.HemisphereLight(16777215, 7829356, 0.62)), t.add(new e.AmbientLight(16777215, 0.34));
        var c = new e.DirectionalLight(16777215, 0.62);
        c.position.set(4, 6, 7), t.add(c);
        var a = new e.DirectionalLight(16777215, 0.3);
        a.position.set(-6, 2, 3), t.add(a);
        var s = new e.DirectionalLight(16774095, 0.45);
        s.position.set(-2, 3, -6), t.add(s);
        var f = new e.MeshStandardMaterial({ color: 15526626, metalness: 0.4, roughness: 0.44 }), y = new e.MeshStandardMaterial({ map: _e(re), metalness: 0.08, roughness: 0.62 }), h = new e.Group();
        h.add(new e.Mesh(new e.CylinderGeometry(0.68, 0.68, 2.95, 96, 1, !0), y));
        var G = new e.Mesh(new e.CylinderGeometry(0.6, 0.68, 0.13, 96), f);
        G.position.y = 1.54, h.add(G);
        var A = new e.Mesh(new e.CylinderGeometry(0.6, 0.6, 0.05, 96), f);
        A.position.y = 1.625, h.add(A);
        var w = new e.Mesh(new e.CylinderGeometry(0.68, 0.6, 0.12, 96), f);
        w.position.y = -1.535, h.add(w), h.rotation.z = -0.06, t.add(h), l = { r: i, scene: t, cam: n, can: h, body: y }, he(), window.ResizeObserver ? new ResizeObserver(he).observe(I) : window.addEventListener("resize", he), be();
      }
    }
    function qe() {
      if (ie = 0, !(!l || !me || document.hidden)) {
        ie = requestAnimationFrame(qe), !g.on && d.autoSpin && !K && (g.spin += g.vel);
        var e = Fe;
        l.can.rotation.y = g.spin + e * 3.2, l.can.position.y = -0.1 + Math.sin(e * Math.PI) * 0.34;
        var t = 1 + e * 0.14;
        l.can.scale.set(t, t, t), l.cam.position.x = e * 0.9, l.cam.lookAt(0, 0, 0), l.r.render(l.scene, l.cam);
      }
    }
    function be() {
      ie || (ie = requestAnimationFrame(qe));
    }
    window.IntersectionObserver && new IntersectionObserver(function(e) {
      me = e[0].isIntersecting, me && be();
    }).observe(Ae), document.addEventListener("visibilitychange", function() {
      document.hidden || be();
    }), I.addEventListener("pointerdown", function(e) {
      g.on = !0, g.x = e.clientX, g.id = e.pointerId, I.classList.add("is-grabbing"), Pe && (Pe.style.opacity = "0");
    }), window.addEventListener("pointermove", function(e) {
      !g.on || e.pointerId !== g.id || (g.spin += (e.clientX - g.x) * 9e-3, g.x = e.clientX);
    }, { passive: !0 });
    function Ie() {
      g.on = !1, g.id = null, I.classList.remove("is-grabbing");
    }
    window.addEventListener("pointerup", Ie), window.addEventListener("pointercancel", Ie), m("[data-flavour]").forEach(function(e) {
      e.addEventListener("click", function() {
        re = e.dataset.flavour, Xe.style.setProperty("--ground", Ye[re]), m("[data-flavour]").forEach(function(t) {
          t.setAttribute("aria-pressed", String(t === e));
        }), l && (l.body.map = _e(re), l.body.needsUpdate = !0);
      });
    });
    function Ke() {
      if (window.THREE) return Oe();
      var e = document.getElementById("bozu-three");
      e || (e = document.createElement("script"), e.id = "bozu-three", e.src = d.threeUrl, e.async = !0, document.head.appendChild(e)), e.addEventListener("load", Oe);
    }
    Ke();
    var S = r("[data-bz-intro]"), Qe = m("[data-t]", S).map(function(e) {
      var t = e.dataset.t.split(",").map(Number);
      return { el: e, a: t[0], b: t[1], rise: t[2] || 14 };
    }), Ze = r("[data-bz-l1]", S), et = r("[data-bz-l2]", S), Re = r("[data-bz-dots]", S), tt = r("[data-bz-caret]", S), at = r("[data-bz-hl]", S), oe = r("[data-bz-big]", S), se = r("[data-bz-cta]", S), nt = r("[data-bz-intro-hint]", S), je = -1;
    function _(e, t, n) {
      return Ue(le((e - t) / (n - t), 0, 1));
    }
    function He(e) {
      var t = e.getBoundingClientRect(), n = e.firstElementChild.offsetHeight, i = t.height - n;
      return i > 0 ? le((N - t.top) / i, 0, 1) : 0;
    }
    function Be(e) {
      if (!(Math.abs(e - je) < 1e-3)) {
        je = e, Qe.forEach(function(s) {
          var f = _(e, s.a, s.b);
          s.el.style.opacity = f, s.el.style.transform = "translateY(" + ((1 - f) * s.rise).toFixed(2) + "px)", s.el.style.filter = f > 0.99 ? "none" : "blur(" + ((1 - f) * 5).toFixed(2) + "px)";
        });
        var t = Math.round(_(e, 0.28, 0.36) * 3), n = Math.round(_(e, 0.385, 0.44) * 3);
        Re.textContent = ".".repeat(Math.max(0, t - n)), tt.style.opacity = e > 0.265 && e < 0.445 ? 1 : 0;
        var i = 1 - _(e, 0.54, 0.6) * 0.5;
        Ze.style.opacity = i, et.style.opacity = i, at.style.setProperty("--hl", (_(e, 0.8, 0.87) * 100).toFixed(1) + "%");
        var c = _(e, 0.86, 0.93);
        oe.style.opacity = c, oe.style.transform = "scale(" + (0.9 + c * 0.1).toFixed(3) + ")", oe.style.filter = c > 0.99 ? "none" : "blur(" + ((1 - c) * 8).toFixed(2) + "px)";
        var a = _(e, 0.92, 0.97);
        se.style.opacity = a, se.style.transform = "translateY(" + ((1 - a) * 10).toFixed(2) + "px)", se.style.pointerEvents = a > 0.5 ? "auto" : "none", nt.style.opacity = 1 - _(e, 0.02, 0.08);
      }
    }
    var ge = !1;
    function V() {
      ge || (ge = !0, requestAnimationFrame(function() {
        ge = !1, Fe = K ? 0 : He(Ae), K || Be(He(S));
      }));
    }
    window.addEventListener("scroll", V, { passive: !0 }), window.addEventListener("resize", V), K ? (oe.style.opacity = 1, se.style.opacity = 1, Re.textContent = "...") : Be(0), V();
    var u = r("[data-bz-sheet]"), X = r("[data-bz-packs]", u), Y = r("[data-bz-mix-add]", u), o = { packs: 1, cells: new Array(12).fill(null), brush: "g", drag: null }, ye = null;
    function rt(e) {
      return e === 1 ? " paket" : e === 2 ? " paketa" : e < 5 ? " paketi" : " paketov";
    }
    function it(e) {
      return e === 1 ? " polje" : e === 2 ? " polji" : e < 5 ? " polja" : " polj";
    }
    function Ge() {
      for (var e = "", t = 0; t < o.packs; t++) {
        e += '<div class="bz-pack"><div class="bz-pack__head"><span class="bz-pack__name">PAKET ' + (t + 1) + '</span><span class="bz-pack__sum" data-sum="' + t + '"></span></div><div class="bz-pack__grid" role="group" aria-label="Paket ' + (t + 1) + '">';
        for (var n = 0; n < 12; n++) e += '<div class="bz-cell" data-cell="' + t + "-" + n + '"></div>';
        e += "</div></div>";
      }
      X.innerHTML = e;
    }
    function We(e) {
      for (var t = Math.min(e.a >> 2, e.b >> 2), n = Math.max(e.a >> 2, e.b >> 2), i = Math.min(e.a % 4, e.b % 4), c = Math.max(e.a % 4, e.b % 4), a = [], s = t; s <= n; s++) for (var f = i; f <= c; f++) a.push(s * 4 + f);
      return { out: a, w: c - i + 1, h: n - t + 1 };
    }
    function R() {
      for (var e = o.drag ? We(o.drag) : null, t = o.brush === "e" ? null : o.brush, n = 0; n < o.packs; n++) {
        for (var i = 0, c = 0, a = 0; a < 12; a++) {
          var s = o.cells[n * 12 + a];
          s === "g" && i++, s === "p" && c++;
          var f = e && o.drag.p === n && e.out.indexOf(a) >= 0, y = f ? t : s, h = X.querySelector('[data-cell="' + n + "-" + a + '"]');
          y ? h.dataset.v = y : delete h.dataset.v, h.classList.toggle("is-sel", !!f);
        }
        var G = X.querySelector('[data-sum="' + n + '"]');
        G.textContent = e && o.drag.p === n ? e.w + " × " + e.h + " → " + (o.brush === "g" ? "Green" : o.brush === "p" ? "Peach" : "Briši") : i + " G · " + c + " P · " + (12 - i - c) + " prazno";
      }
      var A = o.cells.filter(function(E) {
        return E === "g";
      }).length, w = o.cells.filter(function(E) {
        return E === "p";
      }).length, L = o.cells.length - A - w;
      r('[data-bz-tot="g"]', u).textContent = A, r('[data-bz-tot="p"]', u).textContent = w, r('[data-bz-tot="e"]', u).textContent = L, r("[data-bz-packs-label]", u).textContent = o.packs + rt(o.packs), r("[data-bz-mix-price]", u).textContent = Ve(o.packs * d.mixPrice, d.moneyFormat), Y.disabled = L > 0, Y.textContent = L > 0 ? "Zapolni še " + L + it(L) : "Dodaj v košarico", m("[data-brush]", u).forEach(function(E) {
        E.setAttribute("aria-pressed", String(E.dataset.brush === o.brush));
      });
    }
    function De(e) {
      e = le(e, 1, 6);
      for (var t = o.cells.slice(0, e * 12); t.length < e * 12; ) t.push(null);
      o.packs = e, o.cells = t, Ge(), R();
    }
    function Ne(e) {
      var t = document.elementFromPoint(e.clientX, e.clientY), n = t && t.closest && t.closest("[data-cell]");
      if (!n || !X.contains(n)) return null;
      var i = n.dataset.cell.split("-").map(Number);
      return { p: i[0], i: i[1] };
    }
    X.addEventListener("pointerdown", function(e) {
      var t = Ne(e);
      t && (e.preventDefault(), o.drag = { p: t.p, a: t.i, b: t.i }, R());
    }), window.addEventListener("pointermove", function(e) {
      if (o.drag) {
        var t = Ne(e);
        !t || t.p !== o.drag.p || t.i === o.drag.b || (o.drag.b = t.i, R());
      }
    });
    function Je() {
      if (o.drag) {
        var e = o.brush === "e" ? null : o.brush, t = o.drag;
        We(t).out.forEach(function(n) {
          o.cells[t.p * 12 + n] = e;
        }), o.drag = null, R();
      }
    }
    window.addEventListener("pointerup", Je), window.addEventListener("pointercancel", Je), m("[data-brush]", u).forEach(function(e) {
      e.addEventListener("click", function() {
        o.brush = e.dataset.brush, R();
      });
    }), m("[data-preset]", u).forEach(function(e) {
      e.addEventListener("click", function() {
        var t = e.dataset.preset;
        o.cells = o.cells.map(function(n, i) {
          return t === "half" ? i % 4 < 2 ? "g" : "p" : t === "x" ? null : t;
        }), R();
      });
    }), r("[data-bz-pack-dec]", u).addEventListener("click", function() {
      De(o.packs - 1);
    }), r("[data-bz-pack-inc]", u).addEventListener("click", function() {
      De(o.packs + 1);
    });
    function $(e) {
      u.hidden !== !e && (e && (ye = document.activeElement), u.hidden = !e, Q(e), e ? (R(), r("[data-bz-sheet-close]", u).focus()) : (o.drag = null, ye && ye.focus()));
    }
    m("[data-bz-mix-open]").forEach(function(e) {
      e.addEventListener("click", function() {
        $(!0);
      });
    }), r("[data-bz-sheet-close]", u).addEventListener("click", function() {
      $(!1);
    }), u.addEventListener("click", function(e) {
      e.target === u && $(!1);
    }), Y.addEventListener("click", function() {
      if (!d.variants.mix) return Me();
      for (var e = [], t = 0; t < o.packs; t++) {
        var n = o.cells.slice(t * 12, t * 12 + 12), i = n.filter(function(c) {
          return c === "g";
        }).length;
        e.push({ id: d.variants.mix, quantity: 1, properties: { "Green tea": String(i), Peach: String(12 - i) } });
      }
      B(Y, !0), H(e).then(function() {
        o.cells = new Array(o.packs * 12).fill(null), $(!1), te(e.length === 1 ? "Tvoj paket je v košarici." : "Tvoji paketi so v košarici.");
      }).catch(ve).finally(function() {
        B(Y, !1);
      });
    }), Ge(), document.addEventListener("keydown", function(e) {
      e.key === "Escape" && (u.hidden ? ae.hidden || ne(!1) : $(!1));
    }), q();
  }
  function Le() {
    document.querySelectorAll("[data-bz-root]").forEach(we);
  }
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", Le) : Le(), document.addEventListener("shopify:section:load", function(v) {
    we(v.target.querySelector("[data-bz-root]"));
  });
})();